// It is safe to use these components here, because they are available in both
// consumer apps, and the conditional export ensures the right one is used.
import isNewConsumerApp from 'commons/isNewConsumerApp';
import InspirationPageNewConsumerApp from './InspirationPageNewConsumerApp';
import InspirationPageOldConsumerApp from './InspirationPageOldConsumerApp';

const InspirationPage = isNewConsumerApp
  ? InspirationPageNewConsumerApp
  : InspirationPageOldConsumerApp;

export default InspirationPage;
